const getTypeFromLinks = (links) => {
  const blocks = {}
  if (!links || !links.entries) {
    return blocks
  }

  if (links.entries.block) {
    links.entries.block.forEach((block) => {
      if (block?.sys?.id) {
        blocks[block.sys.id] = block.__typename
      }
    })
  }

  if (links.entries.hyperlink) {
    links.entries.hyperlink.forEach((link) => {
      if (link?.sys?.id) {
        blocks[link.sys.id] = {
          slug: link.slug,
          type: link.__typename,
        }
      }
    })
  }
  return blocks
}

export default getTypeFromLinks
